import { useSyncExternalStore } from "react";
import type { CSSProperties } from "react";
import {
  closeLeaderVeeraPanel,
  getLeaderVeeraPanelSnapshot,
  openLeaderVeeraPanel,
  resetLeaderVeeraPanelBoundary,
  restoreLeaderVeeraPanelFocus,
  subscribeToLeaderVeeraPanel,
} from "@/lib/leaderVeeraPanelStore";

export const LEADER_VEERA_PANEL_ID = "leader-veera-panel";
export const LEADER_VEERA_PANEL_WIDTH_PROPERTY = "--leader-veera-panel-width";
export const LEADER_VEERA_PANEL_WIDTH = "clamp(300px,32vw,340px)";
export const LEADER_VEERA_PANEL_WIDTH_STYLE = {
  [LEADER_VEERA_PANEL_WIDTH_PROPERTY]: LEADER_VEERA_PANEL_WIDTH,
} as CSSProperties;

export const useLeaderVeeraPanel = () => {
  const panel = useSyncExternalStore(
    subscribeToLeaderVeeraPanel,
    getLeaderVeeraPanelSnapshot,
    getLeaderVeeraPanelSnapshot,
  );

  return {
    ...panel,
    openPanel: openLeaderVeeraPanel,
    closePanel: closeLeaderVeeraPanel,
    resetBoundary: resetLeaderVeeraPanelBoundary,
    restoreFocus: restoreLeaderVeeraPanelFocus,
  };
};
